import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import RegionsServed from './components/RegionsServed';
import BusinessSolutions from './components/BusinessSolutions';
import ServicesGrid from './components/ServicesGrid';
import Benefits from './components/Benefits';
import Fleet from './components/Fleet';
import SocialProof from './components/SocialProof';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Navbar from './components/Navbar';

const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <TrustBar />
        <RegionsServed />
        <BusinessSolutions />
        <ServicesGrid />
        <Benefits />
        <Fleet />
        <SocialProof />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default HomePage;
